/**
 * Calculate offset for paginated lists.
 * Page is 1-based. Returns 0 for invalid inputs.
 */
export const getOffset = (page: number, limit: number): number => {
  if (!Number.isFinite(page) || !Number.isFinite(limit) || limit <= 0) return 0;
  const safePage = Math.max(1, Math.floor(page));
  const safeLimit = Math.max(1, Math.floor(limit));
  return (safePage - 1) * safeLimit;
};

export default getOffset;
